import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { PERIOD_DAY } from '@/typings/enums/PERIOD_DAY';
import { isNil } from 'lodash-es';
import TempWorkerAvailabilityEntity from '@/entity/TempWorkerAvailabilityEntity';

type Props = SetupProps<typeof UserProfileAvailabilityFlaggedWeekSetupService.props>
type Emits = {(e: 'update:availabilities', val: IAvailabilityModel): void };

export default class UserProfileAvailabilityFlaggedWeekSetupService extends BaseSetupService<Props> {
	static readonly props = {
		availabilityEntity: {
			type: Object as PropType<TempWorkerAvailabilityEntity>,
			required: true as const,
		},
		weekDates: {
			type: Object as PropType<Orion.DateRange>,
			default: undefined,
		},
	};

	private emits: Emits;
	private readonly privateState = reactive({
		PERIOD_DAY,
		week: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'] as const,
		weekend: ['saturday', 'sunday'] as const,
	});

	get PERIOD_DAY () { return this.privateState.PERIOD_DAY; }
	get dayDates () { return this.props.weekDates?.start?.getWeekDays(); }
	get weekend () { return this.privateState.weekend; }
	get week () { return this.privateState.week; }

	get availableMorningWeek () {
		return this.week.filter(x => (this.availabilities[x] & PERIOD_DAY.Morning) === PERIOD_DAY.Morning).length / this.week.length;
	}

	get availableAfternoonWeek () {
		return this.week.filter(x => (this.availabilities[x] & PERIOD_DAY.Afternoon) === PERIOD_DAY.Afternoon).length / this.week.length;
	}

	get availableNightWeek () {
		return this.week.filter(x => (this.availabilities[x] & PERIOD_DAY.Night) === PERIOD_DAY.Night).length / this.week.length;
	}

	get availableMorningWeekend () {
		return this.weekend.filter(x => (this.availabilities[x] & PERIOD_DAY.Morning) === PERIOD_DAY.Morning).length / this.weekend.length;
	}

	get availableAfternoonWeekend () {
		return this.weekend.filter(x => (this.availabilities[x] & PERIOD_DAY.Afternoon) === PERIOD_DAY.Afternoon).length / this.weekend.length;
	}

	get availableNightWeekend () {
		return this.weekend.filter(x => (this.availabilities[x] & PERIOD_DAY.Night) === PERIOD_DAY.Night).length / this.weekend.length;
	}

	get availabilities () { return this.props.availabilityEntity; }
	set availabilities (val) { this.emits('update:availabilities', val); }


	constructor (props: Props, emits: Emits) {
		super(props);
		this.emits = emits;
	}


	updateAvailabilities () {
		this.emits('update:availabilities', this.availabilities);
	}

	handleClickPeriod (period: PERIOD_DAY, days: (typeof this.week | typeof this.weekend), value: number) {
		days.forEach((x) => {
			if (isNil(this.availabilities[x])) {
				this.availabilities[x] = 0;
			}

			if (value === 0 || value === 1) {
				this.availabilities[x] = this.availabilities[x] ^ period;
			} else {
				this.availabilities[x] = this.availabilities[x] | period;
			}
		});

		this.updateAvailabilities();
	}
}
